/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'util/PropTypes';
import CometFooterView from './CometFooterView';
import classNames from 'classnames';

/**
* Comet Card react view
* Customizes ExploreCardView - provides footer visualization in the comet card
*/
@observer
export class CometCardView extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const model = this.props.model;

		const showFooterView = model.cometViewModel.show;
		const cometFooterView = showFooterView ? <CometFooterView
			onAddItem={this.props.onAddItem}
			onClickItem={this.props.onClickItem}
			model={model.cometViewModel}
			dashboardApi={this.props.dashboardApi}
			dataSourceId={this.props.dataSourceId}
			layoutOwner={this.props.layoutOwner}
			logger={this.props.logger}
		></CometFooterView> : null;

		const getFooterView = () => { return cometFooterView; };
		const getCssClasses = this.getCardStyleClasses;
		return this.props.children( null, null, getFooterView, getCssClasses );
	}

	getCardStyleClasses() {
		const showFooterView = this.model.cometViewModel.show;
		const containsPlaceholder = this.model.getVisualizations().length > 1;
		const classNamesMain = classNames({
			'card-layout-main_comet': showFooterView,
			'card-layout-main': !showFooterView
		});
		const classNamesCardRow = classNames({
			'card-row_comet': showFooterView,
			'card-row': !showFooterView && !containsPlaceholder,
			'card-row-placeholder': containsPlaceholder
		});
		return {
			classNamesMain: classNamesMain,
			classNamesCardRow: classNamesCardRow
		};
	}

}

CometCardView.propTypes = {
	model: PropTypes.object,
	children: PropTypes.any,
	dashboardApi: PropTypes.object,
	onAddItem: PropTypes.func,
	onClickItem: PropTypes.func,
	layoutOwner: PropTypes.object,
	dataSourceId: PropTypes.string,
	logger: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/js/layout/explorecard/comet/CometCardView.js